import { baseApi } from '@/model/client/baseApi';
import { goldCreationReducer } from '@/viewmodel/features/analysisSpec';
import { newSourceWizardReducer } from '@/viewmodel/features/etlSource';
import { onboardingProgressReducer } from '@/viewmodel/features/onboarding';
import { projectsReducer } from '@/viewmodel/features/project';
import { organizationReducer, userReducer } from '@/viewmodel/features/user';
import { workspacesReducer } from '@/viewmodel/features/workspace';
import { formReducer } from '@/viewmodel/shared/form';
import { versionCheckReducer } from '@/viewmodel/shared/versionCheck';
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const workspacesPersistConfig = {
  key: 'workspaces',
  storage,
  whitelist: ['currentWorkspace'],
};

export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  userData: userReducer,
  form: formReducer,
  goldCreation: goldCreationReducer,
  newSourceWizard: newSourceWizardReducer,
  onboardingProgress: persistReducer(
    { key: 'onboardingProgress', storage },
    onboardingProgressReducer,
  ),
  organizationData: organizationReducer,
  workspaces: persistReducer(workspacesPersistConfig, workspacesReducer),
  projects: persistReducer({ key: 'projects', storage }, projectsReducer),
  versionCheck: versionCheckReducer,
});
